import { render, staticRenderFns } from "./MostLikesData.vue?vue&type=template&id=5b06ac9f&scoped=true&"
import script from "./MostLikesData.vue?vue&type=script&lang=js&"
export * from "./MostLikesData.vue?vue&type=script&lang=js&"
import style0 from "./MostLikesData.vue?vue&type=style&index=0&id=5b06ac9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b06ac9f",
  null
  
)

export default component.exports